// extracted by mini-css-extract-plugin
module.exports = {"sx-query-bar":"sx-query-bar-3wMjh","with-collapse":"with-collapse-3lTTB","sx-query-bar-collapsed":"sx-query-bar-collapsed-2ISQI","ant-form-item":"ant-form-item-tjJci"};